import { contactForm } from "../components/contact-form";

export default () => {
  const productDetail = $(".type-detail");

  if (productDetail.length > 0) {
    // add short description after headline
    $(".p-short-description").insertAfter(".p-detail-inner-header h1");

    // update product availability & prices
    const availabilityTr = `
    <tr class="availability-row">
      <th>
        <span>Dostupnost:</span>
      </th>
      <td></td>
    </tr>
    `;

    const priceTr = `
    <tr class="price-row">
      <th>
        <span>Cena:</span>
      </th>
      <td></td>
    </tr>
    `;


    const detailParameters = $(".detail-parameters tbody tr");

    // product with variants
    if (detailParameters.length > 0) {
      $(".detail-parameters .variant-list th:contains('Barva')").parent().addClass("color-row");
      $(".detail-parameters .variant-list th:contains('Velikost')").parent().addClass("size-row");

      const sizeRow = $(".size-row");
      const colorRow = $(".color-row");

      // update brand position
      $(".p-detail-info").insertBefore(".detail-parameters");

      // product code
      $(".p-code").insertAfter(".p-detail-info");

      // is product size filled
      if (sizeRow.length > 0) {
        $(availabilityTr).insertAfter(sizeRow);
      } else {
        const availabilityRow = $(".availability-row");
        $(availabilityTr).insertBefore(availabilityRow);
      }

      // is product color filled
      if (colorRow.length > 0) {
        $(priceTr).insertAfter(colorRow);
      } else {
        const availabilityRow = $(".availability-row");
        $(priceTr).insertAfter(availabilityRow);
      }

      $(".price-row td").append($(".p-final-price-wrapper"));
      $(".availability-row td").append($(".availability-value"));

      const sizeTable = document.querySelector(".size-table-img img");

      const sizeTab = `
      <a href="${sizeTable ? sizeTable.src : "https://cdn.myshoptet.com/usr/www.outdiv.cz/user/documents/upload/tabulky_velikosti/2117_m.png" }" data-gallery="lightbox[gallery]" class="cbox-gal cboxElement size-tab">Velikostní tabulka</a>
       `;

      $(".size-row th").append(sizeTab);
    }
    // product withOUT variants
    else {
      // update brand position
      $(".p-detail-info").insertBefore(".detail-parameters");

      // product code
      $(".p-code").insertAfter(".p-detail-info");

      $(".detail-parameters tbody").append(availabilityTr);
      $(".detail-parameters tbody").append(priceTr);

      $(".price-row td").append($(".p-final-price-wrapper"));
      $(".availability-row td").append($(".availability-value"));
    }

    // custom tabs
    const detailTabs = document.querySelector(".p-detail-tabs");
    const customTabDesc = `<li class="shp-tab active"><a href='#description' class="shp-tab-link" role="tab" data-toggle="tab">Popis produktu</a></li>`;
    const customTabContactForm = `<li class="shp-tab"><a href='#contactForm' class="shp-tab-link" role="tab" data-toggle="tab">Dotaz na produkt</a></li>`;

    // remove discussion block
    $("#productDiscussion").remove();

    // import contact form block
    $("#tab-content").append(contactForm);

    const descriptionTab = $(".p-detail-tabs-wrapper").find("#description");
    const contactFormTab = $(".p-detail-tabs-wrapper").find("#contactForm");

    if (descriptionTab.length > 0) {
      detailTabs.innerHTML = customTabDesc;
    }
    if (contactFormTab.length > 0) {
      detailTabs.innerHTML += customTabContactForm;
    }

    // move alternative products block
    const productsAlternativeHeadline = `
      <div class="products-alternative-headline">
        <div class="subheadline">
          Podobné produkty
        </div>
        <div class="h1">
          Nelíbí se vám? Podívejte se na další produkty.
        </div>
      </div>
    `;

    $("#productsAlternative").insertBefore(".showroom");
    $(productsAlternativeHeadline).insertBefore(".products-alternative");

    const relatedTitle = document.querySelector(".products-related-header");
    const relatedProducts = document.querySelector(".products-related.products-additional");
    const relatedBtn = document.querySelector(".browse-p");

    if (relatedTitle && relatedProducts) {

      const pDetail = document.querySelector(".p-detail");

      pDetail.insertAdjacentElement("beforeend", relatedTitle)
      pDetail.insertAdjacentElement("beforeend", relatedProducts)

      if (relatedBtn) {
        pDetail.insertAdjacentElement("beforeend", relatedBtn)

      }
    }
  }
};
